import { Button } from "@/components/ui/button";
import { Crown } from "lucide-react";
import { useNavigate } from "react-router-dom";
import notesWatercolor from "@/assets/notes-watercolor.png";
import { useIsNativeApp } from "@/hooks/useIsNativeApp";
import { TRIAL_PERIOD_DAYS, TRIAL_PRICE_EUR } from "@/config/subscriptionTiers";
import { FACHKRAEFTE_TEXT, gross } from "@/config/webseiteFakten";

interface MembershipFinalCTAProps {
  onStartTrial: () => void;
  isAlreadyMember: boolean;
  isLoggedIn: boolean | null;
}

const MembershipFinalCTA = ({
  onStartTrial,
  isAlreadyMember,
  isLoggedIn,
}: MembershipFinalCTAProps) => {
  const navigate = useNavigate();
  const isNativeApp = useIsNativeApp();
  if (isNativeApp) return null;

  return (
    <section className="py-24 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary/10 via-accent/10 to-primary/10" />

      {/* Decorative watercolor */}
      <div className="absolute bottom-0 right-0 w-80 h-80 opacity-[0.06] translate-x-1/4 translate-y-1/4 pointer-events-none">
        <img src={notesWatercolor} alt="" className="w-full h-full object-contain" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          <h2 className="text-3xl lg:text-5xl font-bold leading-tight">
            Stell dir vor, du hättest{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-accent">
              jeden Tag frische Ideen
            </span>{" "}
            für deine Kinder...
          </h2>

          <p className="text-lg text-muted-foreground leading-relaxed">
            {/* Testphase wie in der Kasse (TRIAL_PERIOD_DAYS, create-abo-subscription) */}
            Teste die Mitgliedschaft {TRIAL_PERIOD_DAYS} Tage für nur {TRIAL_PRICE_EUR} € – du kannst jederzeit kündigen,
            keine versteckten Kosten. {gross(FACHKRAEFTE_TEXT)} vertrauen bereits auf
            MusiKonzept.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <Button
              onClick={onStartTrial}
              disabled={isAlreadyMember}
              size="lg"
              className="bg-gradient-to-r from-primary to-accent hover:from-primary/90 hover:to-accent/90 text-primary-foreground font-semibold text-lg px-8 py-6 rounded-full shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <Crown className="w-5 h-5 mr-2" />
              {isAlreadyMember ? "Du bist bereits Mitglied" : "2 Wochen für 1 € testen"}
            </Button>
            {!isLoggedIn && (
              <Button
                variant="outline"
                size="lg"
                onClick={() => navigate("/registrieren")}
                className="font-semibold text-lg px-8 py-6 rounded-full"
              >
                Erst kostenlos registrieren
              </Button>
            )}
          </div>

          <p className="text-sm text-muted-foreground">
            Noch Fragen?{" "}
            <button
              onClick={() => navigate("/kontakt")}
              className="text-primary hover:underline"
            >
              Kontaktiere uns
            </button>
          </p>
        </div>
      </div>
    </section>
  );
};

export default MembershipFinalCTA;
